import { render, staticRenderFns } from "./OF.vue?vue&type=template&id=7a681b20&"
import script from "./OF.vue?vue&type=script&lang=js&"
export * from "./OF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a681b20')) {
      api.createRecord('7a681b20', component.options)
    } else {
      api.reload('7a681b20', component.options)
    }
    module.hot.accept("./OF.vue?vue&type=template&id=7a681b20&", function () {
      api.rerender('7a681b20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/vistas/empresas/69080200-7/OF.vue"
export default component.exports